import { useEffect, useRef } from 'react';
import { SVGPureIcon } from '@/ui';

const getRandomInt = (min, max) => Math.random() * (max - min) + min;

function MicrophoneIndicator(props) {
  const { active = false } = props;
  const levelElementRef = useRef(null);
  const timerIdRef = useRef(0);

  const update = level => {
    levelElementRef.current.setAttribute('style', `transform:scale(${level})`);
  };

  const breakUpdate = () => {
    if (timerIdRef.current > 0) {
      window.clearInterval(timerIdRef.current);
      timerIdRef.current = 0;
    }
  };

  useEffect(() => {
    if (active) {
      timerIdRef.current = setInterval(() => {
        update(Math.round(getRandomInt(1, 1.5) * 100) / 100);
      }, 100);
    } else {
      breakUpdate();
    }
    return () => breakUpdate();
  }, [active]);

  return (
    <span
      style={{ boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.1)' }}
      className={[
        'relative',
        'rounded-full',
        'p-16px',
        active ? 'bg-[#000]' : 'bg-primary',
      ]}
    >
      <SVGPureIcon
        name="microphone-fill"
        className={[
          'size-48px',
          active ? 'text-white' : 'text-primary opacity-50',
        ]}
      />
      <span
        ref={levelElementRef}
        className={[
          'absolute inset-0 rounded-full',
          'opacity-10',
          'bg-[#999]',
          'transition-transform',
          {
            hidden: !active,
          },
        ]}
      ></span>
    </span>
  );
}

export default MicrophoneIndicator;
